import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { hasAdminSession, getStoredUserData } from "../../../utils/authSession";

/**
 * Admins may only use /admin/* pages.
 * Visiting public, business, or freelancer routes redirects to the admin dashboard.
 */
export function AdminScopeGuard({ children }) {
  const location = useLocation();
  const reduxUserData = useSelector((state) => state.auth.userData);
  const userData = reduxUserData || getStoredUserData();
  const onAdminArea = location.pathname.startsWith("/admin");

  if (hasAdminSession(userData) && !onAdminArea) {
    return <Navigate to="/admin" replace />;
  }

  return children;
}
